import { render, staticRenderFns } from "./reports-view-table.vue?vue&type=template&id=36e15a04&scoped=true&"
import script from "./reports-view-table.ts?vue&type=script&lang=ts&"
export * from "./reports-view-table.ts?vue&type=script&lang=ts&"
import style0 from "./reports-view-table.vue?vue&type=style&index=0&id=36e15a04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e15a04",
  null
  
)

export default component.exports